import SectionHead from "./SectionHead";
import { todayBriefs } from "@/mocks/homeData";

export default function TodayBrief() {
  return (
    <section id="today" className="border-t border-background-200 px-4 py-12 md:px-10 md:py-16">
      <SectionHead
        index="01"
        title="今日提要"
        en="Today's Brief"
        desc="四条编辑挑出的重点，按时间顺序铺开。看完这一块，今天的大致走向就有了轮廓。"
      />

      <div className="grid grid-cols-1 gap-x-14 gap-y-2 md:grid-cols-2">
        {todayBriefs.map((item) => (
          <a
            key={item.index}
            href="#today"
            className="group flex cursor-pointer gap-5 border-b border-background-200 py-6 transition-colors"
          >
            <span className="font-heading text-2xl font-black leading-none text-background-500 transition-colors group-hover:text-primary-500 md:text-3xl">
              {item.index}
            </span>
            <div className="min-w-0">
              <div className="mb-2 flex items-center gap-3 font-label text-[11px] text-foreground-500">
                <span className="font-medium text-primary-600">{item.tag}</span>
                <span>{item.time}</span>
              </div>
              <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}